import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/projects/:projectId/library/members/:memberId`;

type DeleteLibraryMemberResponse = { status: boolean };
type DeleteLibraryMemberDTO = {
  memberId: number;
  projectId: number;
};

export const deleteLibraryMember = ({
  memberId,
  projectId,
}: DeleteLibraryMemberDTO): Promise<DeleteLibraryMemberResponse> => {
  const URL = generateRoutePath(url, { projectId, memberId });

  return axios.delete(URL);
};

type DeleteAddLibraryMemberOptions = {
  config?: MutationConfig<typeof deleteLibraryMember>;
};

export const useDeleteLibraryMember = ({ config }: DeleteAddLibraryMemberOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (props) => deleteLibraryMember(props),
  });
};
